export const fileTypes = [
    {
        id: 0,
        type: 'application/pdf',
        extension: 'pdf',
        fileExtension: 'pdf',
        icon: 'fa-file-pdf',
        style: 'pdf-icon'
    },
    {
        id: 1,
        type: 'application/vnd.ms-excel',
        extension: 'excel',
        fileExtension: 'xlsx',
        icon: 'fa-file-excel',
        style: 'excel-icon'
    },
    {
        id: 2,
        type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        extension:'powerpoint',
        fileExtension: 'pptx',
        icon: 'fa-file-powerpoint',
        style: 'powerpoint-icon'
    },
    {
        id: 3,
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        extension:'word',
        fileExtension: 'docx',
        icon: 'fa-file-word',
        style: 'word-icon'
    }
  ];